import { render } from "./SegmentExpandButton.vue?vue&type=template&id=aa3bd40c&scoped=true"
import script from "./SegmentExpandButton.vue?vue&type=script&lang=js"
export * from "./SegmentExpandButton.vue?vue&type=script&lang=js"

import "./SegmentExpandButton.vue?vue&type=style&index=0&id=aa3bd40c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa3bd40c"]])

export default __exports__